import axios from "axios";
//methods
export const METHODS = {
    GET: "GET",
    POST: "POST",
    CONFIG: "CONFIG"
};

//fetch api
export const fetchAPI = async (method, Url, config = {}) => {
    switch (method) {
        case METHODS.GET:
            return await axios.get(Url);
            break;
        case METHODS.CONFIG:
            return await axios(Url, config);
            break;
        case METHODS.POST:
            return await axios.post(Url, config);
            break;
        default:
            return await axios.get(Url);
            break;
    }

};
